import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { deleteClientById, getFacturationClientByCode, getListProspect } from "../../../Services/Facturation/FacturationClientApi";
import { filterFournisseurByWord } from "../../../Utils/SortObject";
import CopieContent from "../../Exports/CopieContent";
import ExportCsv from "../../Exports/ExportCsv";
import ExportPdf from "../../Exports/ExportPdf";
import CustomSyncLoader from "../../Others/CustomSyncLoader";
import ErrorCustum from "../../Others/ErrorCustum";
import Pagination from "../../Others/Pagination";
import ButtonHeaderComponent from "../../Styles/ButtonHeaderComponent";
import ImageComponent from "../../Styles/ImageComponent";
import { t } from "i18next";


function ListClient() {
  const [currentData, setcurrentData] = useState([]);
  const [allInitialData, setallInitialData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setdata] = useState([]);
  const [size, setsize] = useState(8);
  const [isCollapsed, setisCollapsed] = useState(false);


  const handleChangeSize = (e) => {
    setsize(e.target.value);
    getData();
  };

  const getData = () => {
    setLoading(true);
    getFacturationClientByCode()
      .then((res) => {

        setdata(res.data);
        setallInitialData(res.data);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getData();
  }, []);

  const onChangePage = (pageOfItems) => {
    // update state with new page of items
    setcurrentData(pageOfItems);
  };
  const handleSearch = (e) => {
    if (e.target.value) {
      const dataSearch = filterFournisseurByWord(allInitialData, e.target.value);
      setdata(dataSearch);
    } else {

      setdata(allInitialData);
    }
  };
  // const handleDelete = (id) => {
  //   deleteClientById(id);
  //   setdata(
  //     data.filter((el) => {
  //       return el.id != id;
  //     })
  //   );
  // };

  const handleDelete = (id) => {
    swal({
      title: t("Ëtes-vous sûr ?"),
      text: t("Une fois supprimé, vous ne pourrez pas récupérer cet enregistrement!"),
      icon: "warning",
      // buttons: true,
      buttons: {
        cancel: t("Cancel"), // Traduisez le bouton "Cancel"
        confirm: {
          text: t("OK"), // Traduisez le bouton "OK"
          value: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteClientById(id).then(() => {
          swal(t("Opération effectuée avec succès!"), {
            icon: "success",
          });
          getData();
        });
      }
    });
  };

  const handleCollapse = () => {
    setisCollapsed(!isCollapsed);
  };

  const filtreStatus = (type) => {
    if (type !== 'tout') {
      const dataSearch = allInitialData.filter(item => item.statut === type);
      setdata(dataSearch);

    } else {
      setdata(allInitialData);

    }

  }

  return (
    <div>
      <div className="page-header d-xl-flex d-block">
        <div className="page-leftheader">
          <h4 className="page-title">{t("Client")}</h4>
        </div>
        <div className="page-rightheader ml-md-auto">
          <div className="d-flex align-items-end flex-wrap my-auto right-content breadcrumb-right">
            <div className="btn-list">
              <Link to="/admin/addclient" className="btn btn-primary" data-toggle="modal" data-target="#addclientmodal">
                <i className="feather feather-plus fs-15 my-auto mr-2" />
                {t("Ajouter client")}
              </Link>
              {/* <ButtonHeaderComponent /> */}
            </div>
          </div>
        </div>
      </div>
      {/*End Page header*/}
      {/* Row */}

      <div className="row">
        <div className="col-xl-12 col-md-12 col-lg-12">
          <div className={isCollapsed ? "card  card-fullscreen" : "card"}>
            <div className="card-header  border-0">
              <h4 className="card-title">{t("Liste des clients")}</h4>
              <div className="card-options">
                <Link
                  to="#"
                  className="card-options-fullscreen mr-2"
                  data-toggle="card-fullscreen"
                  onClick={handleCollapse}
                >
                  <i className="fe fe-maximize" />
                </Link>
              </div>
            </div>
            <div className="card-body">
              {/* <div className="row">
                <div className="col-xl-7 col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">From:</label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i className="feather feather-calendar" />
                            </div>
                          </div>
                          <input className="form-control fc-datepicker" placeholder="DD-MM-YYYY" type="text" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">To:</label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i className="feather feather-calendar" />
                            </div>
                          </div>
                          <input className="form-control fc-datepicker" placeholder="DD-MM-YYYY" type="text" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-12">
                  <div className="form-group">
                    <label className="form-label">Select Status:</label>
                    <select
                      name="attendance"
                      className="form-control custom-select select2"
                      data-placeholder="Select Status"
                    >
                      <option label="Select Status" />
                      <option value={1}>Active</option>
                      <option value={2}>InActive</option>
                    </select>
                  </div>
                </div>
                <div className="col-xl-2 col-md-12">
                  <div className="form-group mt-5">
                    <Link to="#" className="btn btn-primary btn-block">
                      Search
                    </Link>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="card-body">
              {loading && <CustomSyncLoader></CustomSyncLoader>}
              {!loading && error && <ErrorCustum></ErrorCustum>}
              {!loading && !error && data && (
                <div className="table-responsive">
                  <div id="hr-table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div className="row">
                      <div className="col-sm-12 col-md-4">
                        <div className="dataTables_length" id="hr-table_length">
                          <label>
                            {t("Afficher")}{" "}
                            <select
                              value={size}
                              className="form-control"
                              id="exampleFormControlSelect1"
                              onChange={handleChangeSize}
                            >
                              <option value={8}>8</option>
                              <option value={20}>20</option>
                              <option value={40}>40</option>
                              <option value={60}>60</option>
                              <option value={100}>100</option>
                            </select>{" "}
                            {t("entrées")}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3">
                        <select onChange={(e) => filtreStatus(e.target.value)} className="form-control" >
                          <option value='tout'>
                            {t('Tout')}
                          </option>
                          <option value='Prospect'>
                            {t('Prospect')}
                          </option>
                          <option value='Client'>
                            {t('Client')}
                          </option>
                        </select>
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <div id="hr-table_filter" className="dataTables_filter">
                          <label className="mr-2">
                            <input
                              type="search"
                              className="form-control"
                              placeholder={t("Recherche...")}
                              aria-controls="hr-table"
                              onChange={handleSearch}
                            />
                          </label>

                          <ExportCsv data={data} name={"List_clients"} />
                          <ExportPdf
                            data={data}
                            name={"List_clients"}
                            columns={["code", "nom", "prenom", "email", "mobile"]}
                          />
                          <CopieContent />

                          {/* <Link to="#" className="action-btns" data-tip="imprimer">
                            <i className="feather feather-printer text-success" />
                          </Link>
                          <Link to="#" className="action-btns" data-tip="partager">
                            <i className="feather feather-share-2 text-warning" />
                          </Link> */}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <table
                          className="table table-vcenter text-nowrap table-bordered border-bottom dataTable no-footer"
                          id="hr-table"
                          role="grid"
                          aria-describedby="hr-table_info"
                        >
                          <thead>
                            <tr>
                              <th className="border-bottom-0 w-5">#{t("ID")}</th>
                              <th className="border-bottom-0">{t("Code")}</th>

                              <th className="border-bottom-0">{t("Nom/Prénom")}</th>
                              <th className="border-bottom-0">{t("Email")}</th>
                              <th className="border-bottom-0">{t("Mobile")}</th>
                              <th className="border-bottom-0">{t("En cour")} {t("solde")}</th>
                              <th className="border-bottom-0">{t("Total facture")}</th>
                              <th className="border-bottom-0">{t("Total Montant")}</th>
                              <th className="border-bottom-0">{t("Actions")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentData.map((el, idx) => (

                              <tr key={idx}>
                                <td># {el.id}</td>
                                <td># {el.code}</td>
                                <td>

                                  <Link to={"/admin/clientactivity/" + el.code} className="d-flex">
                                    <ImageComponent
                                      atr={"avatar avatar-md brround mr-3"}
                                      picture={el.image}
                                    ></ImageComponent>
                                    <div className="mr-3 mt-0 mt-sm-2 d-block">
                                      <h6 className="mb-1 fs-14">
                                        {el.nom} {el.prenom}
                                      </h6>
                                    </div>
                                  </Link>
                                </td>
                                <td>{el.email}</td>
                                <td>{el.mobile}</td>
                                <td>
                                  <span className="badge badge-danger-light">{(el.total_montant_ttc - el.total_montant_encaissement).toFixed(3)}</span>
                                </td>
                                <td>{el.total_montant_ttc}</td>
                                <td>{el.total_montant_encaissement || 0}</td>
                                <td>
                                  <div className="d-flex">
                                    {/* <a
                                      href="client-view.html"
                                      className="action-btns1"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="View"
                                    >
                                      <i className="feather feather-eye text-primary" />
                                    </a> */}
                                    <Link
                                      to={"/admin/client/" + el.id}
                                      className="action-btns1"
                                      data-toggle="modal"
                                      data-target="#editclientmodal"
                                    >
                                      <i
                                        className="feather feather-edit-2  text-success"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Edit"
                                      />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="action-btns1"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Delete"
                                      onClick={() => handleDelete(el.id)}
                                    >
                                      <i className="feather feather-trash-2 text-danger" />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div className="dataTables_info" id="hr-table_info" role="status" aria-live="polite">
                          {t("Affichage")} {t("de")} 1 {t("à")} {size} {t("sur")} {data.length} {t("entrées")}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <Pagination items={data} onChangePage={onChangePage} pageSize={size} />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ListClient;
